import React from "react";

import "./WashingtonStateTaxDisclaimer.scss";

const WashingtonStateTaxDisclaimer = () => (
	<div className="washington-state-tax-disclaimer">
		Washington residents are required to pay sales or use tax on
		certain purchases. Washington law requires Washington purchasers
		to review untaxed purchases and, if any tax is owed, file a
		Washington use tax return and pay any tax due. Visit
		{" "}
		<a href="https://dor.wa.gov/consumerusetax" target="_blank" rel="noopener noreferrer">
			https://dor.wa.gov/consumerusetax
		</a>
		{" "}
		for more information. This notice is required by Engrossed House
		Bill 2163, section 205(2)(a).
	</div>
);

export default WashingtonStateTaxDisclaimer;



// WEBPACK FOOTER //
// ./src/apps/payment/components/WashingtonStateTaxDisclaimer/WashingtonStateTaxDisclaimer.jsx